// One business call every 6 hours (23 Oct 2026, mock B2BLimit_1): when a car owner or driver
// account has already called a business in the last 6 hours, the call is held back and this
// sheet says when they can call next - in their language - with Sramika's number for an
// urgent trip. The server decides (backend utils/businessCallLimit.js); the page only shows it.
//
//   catch (err) { if (showBusinessLimit(err)) return; … }

import { useEffect, useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { CALL_NUMBER, prettyNumber } from "../utils/contactNumbers";
import { dateLocale } from "../utils/leadDisplay";

const EVENT = "sramika:business-limit";

/** Shows the sheet when `err` is the 6-hour answer; returns whether it did. */
export function showBusinessLimit(err) {
  if (err?.code !== "BUSINESS_CALL_LIMIT") return false;
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { nextAt: err.nextAt || null } }));
  return true;
}

export default function BusinessLimitHost() {
  const { t, lang } = useLanguage();
  const [nextAt, setNextAt] = useState(undefined);
  useEffect(() => {
    const open = (e) => setNextAt(e.detail.nextAt);
    window.addEventListener(EVENT, open);
    return () => window.removeEventListener(EVENT, open);
  }, []);
  if (nextAt === undefined) return null;

  const d = new Date(nextAt);
  const sameDay = !Number.isNaN(d.getTime()) && d.toDateString() === new Date().toDateString();
  const when = Number.isNaN(d.getTime()) ? "" : (sameDay ? `${t("lp_today")} ` : `${t("lp_tomorrow")} `)
    + d.toLocaleTimeString(dateLocale(lang), { hour: "numeric", minute: "2-digit" });
  const close = () => setNextAt(undefined);

  return (
    <div className="fixed inset-0 z-[300] flex items-end lg:items-center justify-center bg-black/40" onClick={close}>
      <div role="dialog" aria-modal="true" aria-label={t("bl_title")} onClick={(e) => e.stopPropagation()}
        className="w-full max-w-[440px] bg-white rounded-t-[20px] lg:rounded-[20px] p-4 space-y-3 pb-[max(16px,env(safe-area-inset-bottom))]">
        <span aria-hidden="true" className="w-11 h-11 rounded-full bg-[#FEF3C7] flex items-center justify-center text-[22px]">⏳</span>
        <p className="text-[16px] font-extrabold text-[#0F172A] leading-snug">{t("bl_title")}</p>
        <p className="text-[13px] text-[#475569] leading-relaxed">{t("bl_body")}</p>
        {when && <p className="rounded-xl bg-[#F1F7E3] border border-[#D6E6B0] px-3 py-2.5 text-[13.5px] font-extrabold text-[#3F5E00]">{t("bl_next").replace("{when}", when)}</p>}
        <a href={`tel:+91${CALL_NUMBER}`} className="block rounded-xl border-[1.5px] border-[#7BAE00] px-3 py-3 text-center text-[13px] font-extrabold text-[#3F5E00]">
          {t("bl_urgent")} · 📞 {prettyNumber(CALL_NUMBER)}
        </a>
        <button type="button" onClick={close} className="w-full h-[46px] rounded-xl bg-[#0F172A] text-white text-[13.5px] font-extrabold">{t("bl_ok")}</button>
      </div>
    </div>
  );
}
